import { render, staticRenderFns } from "./GalleryMessageEditor.vue?vue&type=template&id=309ed2cc&scoped=true"
import script from "./GalleryMessageEditor.vue?vue&type=script&lang=js"
export * from "./GalleryMessageEditor.vue?vue&type=script&lang=js"
import style0 from "./GalleryMessageEditor.vue?vue&type=style&index=0&id=309ed2cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309ed2cc",
  null
  
)

export default component.exports